<template>
  <div class="tiles-wrapper pb-profile-family-selector">
    <label
      v-for="family in config.properties.modelsFamilies"
      :key="family.value"
      class="tile"
      :class="{
        clickable: !(loading || disabled),
        disabled,
      }"
    >
      <input
        v-model="selected"
        class="pb-profile-family-selector-radio-input"
        type="radio"
        :name="id"
        :value="family.value"
        :disabled="(loading || disabled)"
      >
      <div class="tile-content">
        <div
          v-if="loading || (disabled && selected !== family.value)"
          class="pb-profile-family-selector-loader"
        >
          <Spinner v-if="loading && selected === family.value" />
        </div>
        <div class="tile-image">
          <Asset
            :src="family.icon"
            :alt="translate(family.label)"
            :placeload-centered="true"
            placeload-size="medium"
          />
        </div>
        <div class="tile-label">{{ translate(family.label) }}</div>
      </div>
    </label>
  </div>
</template>

<script setup>
import { watch } from 'vue'

import usePropSync from '@nicolaudie-group/ng-ui-kit/composables/usePropSync'
import generateId from '@nicolaudie-group/ng-ui-kit/helpers/generateId'
import Asset from '@nicolaudie-group/ng-ui-kit/components/Asset/Asset.vue'
import Spinner from '@nicolaudie-group/ng-ui-kit/components/Spinner/Spinner.vue'

import config from '@/config'
import useTranslate from '@/composables/useTranslate'

const props = defineProps({
  value: { type: Number, required: true },
  loading: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
})

const emit = defineEmits(['input', 'change'])

const { translate } = useTranslate()

const id = generateId('pb-profile-family-selector')

const selected = usePropSync(props, { key: 'value' })

watch(selected, (newSelected) => {
  emit('input', newSelected)
  emit('change', newSelected)
})
</script>

<style lang="scss" src="./FamilySelector.scss" />
